type FieldErrorShape = { message?: unknown; [key: string]: unknown }

export const translateFieldErrors = <TErrors extends Record<string, unknown>>(
  errors: TErrors,
  translate: (code: string) => string
): TErrors =>
  Object.fromEntries(
    Object.entries(errors).map(([field, error]) => {
      const shaped = error as FieldErrorShape
      return [
        field,
        typeof shaped?.message === 'string'
          ? { ...shaped, message: translate(shaped.message) }
          : shaped,
      ]
    })
  ) as TErrors
